export const DEFAULT_FPS = 30;

export const Z_INDEX = {
  BACKGROUND: 0,
  SCREEN: 1,
  WEBCAM: 2,
  OVERLAY: 10,
  WATERMARK: 100,
} as const;

export const DEFAULT_CORNER_RADIUS = {
  SCREEN: 12,
  WEBCAM: 0,
} as const;

// Shadow configuration matching canvas behavior
export const DEFAULT_SHADOW = {
  WEBCAM: {
    color: 'rgba(0, 0, 0, 0.28)',
    blur: 18,
    offsetX: 2,
    offsetY: 4,
  },
  SCREEN: {
    color: 'rgba(0, 0, 0, 0.15)',
    blur: 12,
    offsetX: 0,
    offsetY: 2,
  },
} as const;

export const COMPOSITOR_VERSION = '1.0';
